<template>
    <div ref="gantt" id="gantt"></div>
</template>

<script>

    import 'dhtmlx-gantt';
    import 'dhtmlx-gantt/codebase/sources/ext/dhtmlxgantt_marker';
    import 'dhtmlx-gantt/codebase/sources/ext/dhtmlxgantt_fullscreen';
    import '../../Libraries/dhtmlx/api';

    export default {

        data() {
            return {
                scaleConfigs: [
                    // minutes
                    {
                        unit:"minute",
                        step:1,
                        scale_unit:"hour",
                        date_scale:"%H",
                        subscales:[
                            {unit:"minute",step:1,date:"%H:%i"}
                        ]
                    },
                    // hours
                    {
                        unit:"hour",
                        step:1,
                        scale_unit:"day",
                        date_scale:"%j %M",
                        subscales:[
                            {unit:"hour",step:1,date:"%H:%i"}
                        ]
                    },
                    // days
                    {
                        unit:"day",
                        step:1,
                        scale_unit:"month",
                        date_scale:"%F",
                        subscales:[
                            {unit:"day",step:1,date:"%j"}
                        ]
                    },
                    // weeks
                    {
                        unit:"week",
                        step:1,
                        scale_unit:"month",
                        date_scale:"%F",
                        subscales:[
                            {
                                unit:"week",step:1,template:function(date){
                                    let dateToStr = gantt.date.date_to_str("%d %M");
                                    let endDate = gantt.date.add(gantt.date.add(date,1,"week"),-1,"day");
                                    return dateToStr(date) + " - " + dateToStr(endDate);
                                }
                            }
                        ]
                    },
                    // months
                    {
                        unit:"month",
                        step:1,
                        scale_unit:"year",
                        date_scale:"%Y",
                        subscales:[
                            {unit:"month",step:1,date:"%M"}
                        ]
                    },
                    // quarters
                    {
                        unit:"month",
                        step:3,
                        scale_unit:"year",
                        date_scale:"%Y",
                        subscales:[
                            {
                                unit:"month",step:3,template:function(date){
                                    let dateToStr = gantt.date.date_to_str("%M");
                                    let endDate = gantt.date.add(gantt.date.add(date,3,"month"),-1,"day");
                                    return dateToStr(date) + " - " + dateToStr(endDate);
                                }
                            }
                        ]
                    },
                    // years
                    {
                        unit:"year",
                        step:1,
                        scale_unit:"year",
                        date_scale:"%Y",
                        subscales:[
                            {
                                unit:"year",step:5,template:function(date){
                                    let dateToStr = gantt.date.date_to_str("%Y");
                                    let endDate = gantt.date.add(gantt.date.add(date,5,"year"),-1,"day");
                                    return dateToStr(date) + " - " + dateToStr(endDate);
                                }
                            }
                        ]
                    },
                    // decades
                    {
                        unit:"year",
                        step:10,
                        scale_unit:"year",
                        template:function(date){
                            let dateToStr = gantt.date.date_to_str("%Y");
                            let endDate = gantt.date.add(gantt.date.add(date,10,"year"),-1,"day");
                            return dateToStr(date) + " - " + dateToStr(endDate);
                        },
                        subscales:[
                            {
                                unit:"year",
                                step:100,
                                template:function(date){
                                    let dateToStr = gantt.date.date_to_str("%Y");
                                    let endDate = gantt.date.add(gantt.date.add(date,100,"year"),-1,"day");
                                    return dateToStr(date) + " - " + dateToStr(endDate);
                                }
                            }
                        ]
                    }
                ],
            }
        },

        destroyed(){
            gantt.destructor();
            location.href = location.href;
        },

        methods: {
            addMarker() {
                let date_to_str = gantt.date.date_to_str(gantt.config.task_date);
                let today = new Date();

                gantt.addMarker({
                    start_date:today,
                    css:"today",
                    text:"Today",
                    title:"Today: " + date_to_str(today)
                });
            },

            startGantt() {
                gantt.init(this.$refs.gantt, new Date(this.range[0]), new Date(this.range[1]));
                document.getElementById("gantt").style.height = (window.innerHeight) + 'px';
                gantt.parse(this.tasks);
            },

            defaultZoom() {
                let project = gantt.getSubtaskDates(),
                    areaWidth = gantt.$task.offsetWidth,
                    identifier;
                // Loop through the scaleConfigs
                for (let i = 0; i < this.scaleConfigs.length; i++) {
                    // Get the column count
                    let columnCount = this.getColumnCount(project.start_date, project.end_date, this.scaleConfigs[i]);
                    // Check width
                    if (((columnCount + 2) * gantt.config.min_column_width) <= areaWidth) {
                        // Set identifier
                        identifier = i;
                        // Break the loop so we can use the identifier.
                        break;
                    }
                }
                // Make sure identifier is set
                if (!identifier) {
                    identifier = this.scaleConfigs.length - 1;
                }
                // Set scale
                if (identifier === 7) {
                    // The 10-yearly scale does not work, so use the yearly in that case.
                    identifier = 6;
                }
                this.setScale(this.scaleConfigs[identifier]);
            },
            getColumnCount(start_date, end_date, scaleConfig) {
                let start = new Date(start_date),
                    end = new Date(end_date),
                    columns = 0;
                // Loop
                while (start.valueOf() < end.valueOf()) {
                    columns++;
                    start = gantt.date.add(start, scaleConfig.step, scaleConfig.unit);
                }
                // Return count
                return columns;
            },
            setDefaultConfig() {
                gantt.config.drag_move = false;
                gantt.config.drag_links = false;
                gantt.config.drag_resize = false;
            },
            setDefaultGanttListeners(){
                // On expand
                gantt.attachEvent("onExpand", () => {
                    // Hide the header and sidebar
                    jQuery("header").hide();
                    jQuery("aside").hide();
                    // Refire within vue
                    this.$emit("gantt-expanded");
                });
                // On collapse
                gantt.attachEvent("onCollapse", () => {
                    // Show the header and sidebar
                    jQuery("header").show();
                    jQuery("aside").show();
                    // Refire within vue
                    this.$emit("gantt-collapsed");
                });
            },
            setScale(scale) {
                // Set data
                gantt.config.scale_unit = scale.scale_unit;
                gantt.config.step = scale.step;
                gantt.config.subscales = scale.subscales;
                // Check date scale
                if (scale.date_scale) {
                    gantt.config.date_scale = scale.date_scale;
                    gantt.templates.date_scale = null;
                } else {
                    gantt.config.date_scale = scale.template;
                }
                gantt.config.start_date = gantt.config.end_date = null;
            },
        },

        mounted() {
            // Set default config
            this.setDefaultConfig();
            // Add marker
            this.addMarker();
            // Set default listeners
            this.setDefaultGanttListeners();
        },

        name: "BaseGantt",

        props: {
            tasks: {
                required:true,
                type:Object,
                default:{
                    data: [],
                    links: [],
                }
            },
            range: {
                required:true,
                type:Array,
                default:['',''],
            },
        }
    }

</script>
